export default __webpack_public_path__ + "static/media/moto-2.856d5311.jpg";